import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  DeleteAddition,
  DeleteService,
  GetAdditionsList,
  GetNewServiceList,
} from '../../state/service-action';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { NewServicesState } from '../../state/ayen-service.state';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';

@Component({
    selector: 'dynamic-additions',
    templateUrl: './dynamic-additions.component.html',
    styleUrl: './dynamic-additions.component.scss',
    standalone: false
})
export class DynamicAdditionsComponent implements OnInit, OnDestroy{
  disabledDelete: boolean = true;
  config: any;
  page: number = 1;
  page_size: number = 20;
  totalRecords: any = 0;
  services: any;
  additionList: any;
  searchValue: any;
  showSpinner: boolean = true;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  AdditionsList$: Observable<any>;
  additionsSubscribtion: Subscription;

  payload: { page: number; query: string; page_size: number } = {
    page: this.page,
    query: '',
    page_size: this.page_size,
  };
  currentItemsPerPage: number;
  @ViewChild('goUp', { static: true }) contentPage: ElementRef;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private store: Store,
    private route: ActivatedRoute
  ) {
    this.AdditionsList$ = this.store.select(NewServicesState.getAdditionList);
    this.config = {
      id: 'additionList',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.page && params.page_size) {
        this.page = Number(params.page)
        this.page_size = Number(params.page_size)
        this.config.currentPage = Number(params.page)
        this.config.itemsPerPage = Number(params.page_size)
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }
    });
    this.getDynamicAdditions();
  }
  ngOnDestroy(): void {
    this.additionsSubscribtion.unsubscribe();
  }
  getDynamicAdditions() {
    this.showSpinner = true;
    this.payload = {
      page: this.config.currentPage,
      query: '',
      page_size: this.config.itemsPerPage,
    };
    if (this.searchValue) {
      this.payload['query'] = this.searchValue;
    }
    this.additionsSubscribtion =  this.AdditionsList$.subscribe(
      (data) => {
        if (data && data['results']) {
          this.showSpinner = false;
          this.additionList = data.results;
          this.config['totalItems'] = data.count;
          this.currentItemsPerPage = data.results.length;
        } else {
          this.store.dispatch(new GetAdditionsList(this.payload));
        }
      },
      (error) => {
        try {
          this.showSpinner = false;
        } catch {}
      }
    );
  }

  showDeleteConfirmationBox(id, index, name) {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: id,
        index: index,
        message: `هل أنت متأكد من حذف خدمة "${name}"؟`,
      },
    });
    this.deleteDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteService(result);
      }
    });
  }

  deleteService(event) {
    this.store.dispatch(new DeleteAddition(event.id));
  }

  changeToSpecific(event) {
    this.pageChanged(event)
  }
  pageChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.showSpinner = value,
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.payload['page'] = event;
    this.store.dispatch(new GetAdditionsList(this.payload));
  }
  pageSizeChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.showSpinner = value,
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.payload['page_size'] = event;
    this.store.dispatch(new GetAdditionsList(this.payload));
  }

  quickSearch(event) {
    this.showSpinner = true;
    this.searchValue = event;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.payload = {
      page: this.config.currentPage,
      query: this.searchValue ?? '',
      page_size: this.config.itemsPerPage,
    };
    this.store.dispatch(new GetAdditionsList(this.payload));
  }

  goAdditionDetails(id) {
    this.router.navigate([`pages/services/additions/edit/${id}`]);
  }
}
